<div class="m-navbar"
    :class="[
        'm--is-skin-' + skin,
        {
            'm--is-disabled': disabled,
            'm--is-anim-ready': animReady,
            'm--is-multiline': multiline
        }
    ]">
    <m-auto-horizontal-scroll class="m-navbar__wrap"
                            :style="{ maxWidth: maxWidth }"
                            :min-width="minWidth"
                            :horizontal-scroll-offset.sync="horizontalScrollOffset"
                            :drag-active="true"
                            :left-gradient-active="hasGradient"
                            :right-gradient-active="hasGradient"
                            :gradient-style="gradientStyle"
                            :previous-button-active="navigationArrow"
                            :next-button-active="navigationArrow"
                            :previous-button-text="titleButtonLeft"
                            :next-button-text="titleButtonRight"
                            :display-horizontal-scrollbar="false"
                            @resize="resizeComponant($event)"
                            @previous-button-click="onPreviousButtonClick($event)"
                            @next-button-click="onNextButtonClick($event)">

        <ul class="m-navbar__list"
            role="menubar"
            ref="list">
            <slot />
            <li v-if="isTabUnderlineSkin"
                class="m-navbar__line"
                ref="tab-underline"
                role="none"
                aria-hidden="true"></li>
            <li v-if="isTabArrowSkin"
                class="m-navbar__arrow"
                ref="tab-arrow"
                role="none"
                aria-hidden="true"></li>
        </ul>
    </m-auto-horizontal-scroll>
</div>
